export namespace PandemieConfigTypes {
    export const PANDEMIE_MANDANT_OPTIONS = 'pan-pandemie';
    export const PANDEMIE_VERANSTALTUNG_TYP_KONFIGURATION_MANDANT_OPTIONS = 'pan-typ-konfig';
    
}

